/*
  Cart drawer: strikethrough "was" price on sale lines (Otto, 2026-09-27, Chris ask).

  cart-drawer.js only strikes a price when a DISCOUNT lowers the line
  (original_line_price > final_line_price). A sale item's compare-at price is not
  in /cart.js, so sale lines rendered as a plain price. This add-on watches the
  rendered items, reads each line's compare-at from /products/<handle>.js, and
  adds the same sale + compare spans cart-drawer.js uses for discounted lines.
  It never edits cart-drawer.js and never changes a price, only the display.

  Also (Chris, 2026-09-27): when a code rode in on a /discount/ link and takes
  $0 because everything in the bag is already marked down, a one-line note under
  the subtotal says why. Gift codes (FREEGIFT, FREETEE, NEWGIFT) have their own
  prompt and are skipped.
*/
(function () {
  'use strict';

  var CACHE_KEY = 'po_cmp_v1';
  var TTL_MS = 10 * 60 * 1000;
  var productCache = {};
  var inflight = {};
  var running = false;
  var rerun = false;

  try {
    var saved = JSON.parse(sessionStorage.getItem(CACHE_KEY) || '{}');
    if (saved && saved.t && Date.now() - saved.t < TTL_MS) productCache = saved.p || {};
  } catch (e) {}

  function persist() {
    try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), p: productCache })); } catch (e) {}
  }

  function money(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(cents); } catch (e) {}
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function compareMap(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    if (inflight[handle]) return inflight[handle];
    inflight[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        var map = {};
        (p && p.variants || []).forEach(function (v) {
          if (v.compare_at_price && v.compare_at_price > v.price) map[v.id] = v.compare_at_price;
        });
        productCache[handle] = map;
        persist();
        delete inflight[handle];
        return map;
      })
      .catch(function () { delete inflight[handle]; return {}; });
    return inflight[handle];
  }

  var GIFT_CODE = /^(FREEGIFT|FREETEE|NEWGIFT)(-|$)/i;
  var NOTE_TEXT = 'Codes apply to full-price items. Sale items are already marked down.';

  function codeNote(cart) {
    var codes = (cart.discount_codes || []).filter(function (d) { return d && d.code && !GIFT_CODE.test(d.code); });
    var show = codes.length > 0 && (cart.items || []).length > 0 && !cart.total_discount;
    var note = document.getElementById('po-cart-code-note');
    if (!note) {
      if (!show) return;
      var sub = document.getElementById('po-cart-subtotal');
      if (!sub || !sub.parentNode) return;
      note = document.createElement('p');
      note.id = 'po-cart-code-note';
      note.style.cssText = 'margin:0;padding:8px 20px;border-bottom:1px solid #eee;font-size:12px;line-height:1.4;color:#555;';
      note.textContent = NOTE_TEXT;
      sub.parentNode.insertBefore(note, sub.nextSibling);
    }
    note.hidden = !show;
  }

  function decorate() {
    var container = document.getElementById('po-cart-items');
    if (!container || !container.querySelector('.po-cart-item')) return Promise.resolve();
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        codeNote(cart);
        var byKey = {};
        (cart.items || []).forEach(function (i) { byKey[i.key] = i; });
        var handles = {};
        (cart.items || []).forEach(function (i) { if (i.handle) handles[i.handle] = true; });
        return Promise.all(Object.keys(handles).map(compareMap)).then(function () {
          container.querySelectorAll('.po-cart-item').forEach(function (el) {
            var item = byKey[el.getAttribute('data-key')];
            if (!item || !item.handle) return;
            var unitCompare = (productCache[item.handle] || {})[item.variant_id];
            if (!unitCompare) return;
            var wasCents = unitCompare * item.quantity;
            if (wasCents <= item.final_line_price) return;
            var priceEl = el.querySelector('.po-cart-item-price');
            if (!priceEl) return;
            var cmp = priceEl.querySelector('.po-cart-item-price-compare');
            if (cmp) {
              // Discounted line already struck at the pre-discount price; show the true "was" price.
              if (wasCents > item.original_line_price) cmp.textContent = money(wasCents);
              return;
            }
            priceEl.innerHTML = '<span class="po-cart-item-price-sale">' + money(item.final_line_price) + '</span>' +
              '<span class="po-cart-item-price-compare">' + money(wasCents) + '</span>';
          });
        });
      })
      .catch(function () {});
  }

  function schedule() {
    if (running) { rerun = true; return; }
    running = true;
    decorate().then(function () {
      running = false;
      if (rerun) { rerun = false; schedule(); }
    });
  }

  function start() {
    var container = document.getElementById('po-cart-items');
    if (!container) return;
    new MutationObserver(function (muts) {
      // Ignore our own edits inside a price cell; react only when lines are re-rendered.
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t === container || (t.nodeType === 1 && !t.closest('.po-cart-item-price'))) { schedule(); return; }
      }
    }).observe(container, { childList: true, subtree: true });
    schedule();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
